import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { retrieveDisclosures } from "../../Services/DisclosureApiService";
import { retrieveStockInfo } from "../../Services/StockSessionApiService";
import ReactPaginate from "react-paginate";
import { useCookies } from "react-cookie";
import { Link } from "react-router-dom";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dropdown } from 'primereact/dropdown';
import { Avatar } from "primereact/avatar";
import { Calendar } from 'primereact/calendar';
import DividendDialog from "../../Components/PrimeReact/Dividend/dialog";
import LogoHeader from "../../Components/PrimeReact/logoBanner";
import { useAuthHeader } from "../../auth/AuthService";

export default function Disclosure() {
    const [cookies, setCookie] = useCookies(['icode', 'bType', 'startDate', 'endDate']);
    const {t, i18n} = useTranslation();
    const [startDate, setStartDate] = useState(new Date(new Date().setMonth(new Date().getMonth() - 2)));
    const [endDate, setEndDate] = useState(new Date());
    const [disclosures , setDisclosures] = useState([]);
    const [dividends, setDividends] = useState([]);
    const [stock, setStock] = useState([]);
    const [mType, setMType] = useState(cookies.bType);
    const [icode, setIcode] = useState(cookies.icode);
    const authHeader = useAuthHeader();

    const[currentPage, setCurrentPage] = useState(1);
    const[totalPages, setTotalPages] = useState(0);
    const[totalDis, setTotalDis] = useState(0);
    const[totalDisinPage, setTotalDisinPage] = useState(0);
    const [loading, setLoading] = useState(false);

    const boards = [
        { name: t('Main Board'), value: 'M' },
        { name: t('Growth Board'), value: 'G' },
    ];
    const [icodes, setIcodes] = useState([]);

    async function getDisclosure() {
        setLoading(true);
        let sDate = startDate.getFullYear() + '-' + ('0'+ (startDate.getMonth()+1)).slice(-2) + '-' + ('0'+ startDate.getDate()).slice(-2);
        let eDate = endDate.getFullYear() + '-' + ('0'+ (endDate.getMonth()+1)).slice(-2) + '-' + ('0'+ endDate.getDate()).slice(-2);
        await retrieveDisclosures(sDate, eDate, icode, i18n.language, currentPage, 20, mType, authHeader())
        .then((response) => {
            let data = response.data.data.disclosures;
            setDividends(response.data.data.devidends);
            setDisclosures(data.content);
            setTotalPages(data.totalPages);
            setTotalDis(data.totalElements);
            setTotalDisinPage(data.numberOfElements);
            setLoading(false);
        })
        .catch((error) => { console.log(error) })
    }

    async function getStock() {
        await retrieveStockInfo(mType, null, authHeader())
        .then((response) => {
            let stock = response.data.data.stock.sort(function(a, b) {
                if (a.isymbol < b.isymbol) return -1;
                if (a.isymbol > b.isymbol) return 1;
                return 0;
            });
            stock.unshift({
                id: 0,
                icode: '',
                isymbol: 'All Stock'
            })
            setStock(stock);
            let icodes = stock.map((v) => ({'name': v.isymbol, 'value': v.icode}));
            setIcodes(icodes);
        })
        .catch((error) => console.log(error));
    }

    const onChangeMType = (e) => {
        let val = e.value;
        setMType(val);
        setCookie('bType', val);
        setIcode('');
        setCookie('icode', '');
        setCurrentPage(1);
    }
    
    const onChangeICode = (e) => {
        let val = e.value;
        setIcode(val);
        setCookie('icode', val);
        setCurrentPage(1);
    }

    const onChangeSDate = (e) => {
        let val = e.value;
        setStartDate(val);
        setCookie('startDate', val);
        setCurrentPage(1);
    }

    const onChangeEDate = (e) => {
        let val = e.value;
        setStartDate(val);
        setCookie('endDate', val);
        setCurrentPage(1);
    }

    const onChangePage = (e) => {
        setCurrentPage(e.selected+1);
    }

    function init() {
        cookies.startDate && setStartDate(new Date(cookies.startDate));
        cookies.endDate && setEndDate(new Date(cookies.endDate));
    }

    useEffect(() => {
        init();
        getDisclosure();
    },[mType, currentPage, icode, startDate.toISOString(), endDate.toISOString(), i18n.language]);

    useEffect(() => {
        getStock();
    }, [mType])

    const dateBodyTemplate = (rowData) =>  {
        return (
            <div className="flex justify-content-center">
                <span className="flex text-sm">{rowData.tdate && (rowData.tdate.substr(0,4)+"-"+rowData.tdate.substr(4,2)+"-"+rowData.tdate.substr(6,2))}</span>
            </div>
        );
    }
    const symbolBodyTemplate = (rowData, index) =>  {
        let stockIssue = stock && stock.filter((v) => v.icode == rowData.icode)[0];
        let v = dividends[index?.rowIndex];
        let diviSign =1
        let txtdiv = '';
        if (v.divi == 1) {
            txtdiv = <img src="/img/d-sign.png" className="vertical-align-super" />;
            diviSign = 1;
        }

        if (v.xd == 1) {
            txtdiv = <img src="/img/xd-sign.png" className="vertical-align-super" />;
            diviSign = 2;
        }
        let dividend = {
            "stock": stockIssue?.isymbol,
            "lp": stockIssue?.ilp,
            "diviSign": diviSign,
            "txtdiv": txtdiv,
            "type_of_dividend": v?.dividend?.itypeDividend,
            "dividend_per_share": v?.dividend?.idividendPerShare,
            "ex_dividend_date": v?.dividend?.iexDividendDate,
            "record_date": v?.dividend?.irecodeDate,
            "payment_date": v?.dividend?.ipaymentDate,
            "link": v?.dividend?.iwebsiteLink
        }
        return (
            <div className="flex justify-content-center">
                <span className='flex text-sm'>
                    {stockIssue && stockIssue.isymbol}&nbsp;
                    <DividendDialog issue={dividend}></DividendDialog>
                </span>
            </div>
        );
    }
    const dTypeBodyTemplate = (rowData) =>  {
        return (
            <div className="flex justify-content-center">
                <span className='flex align-items-center text-sm'>
                     
                </span>
            </div>
        );
    }
    const dTitleBodyTemplate = (rowData) =>  {
        return (
            <div className="flex justify-content-start">
                <span className="flex text-sm"><Link className="stock-link text-left" to={`/disclosures/`+rowData.id}>{rowData.dtdcontents}</Link></span>
            </div>
        );
    }
    const icodeOptionTemplate = (option) => {
        return (
            <div className="flex align-items-center">
                <Avatar image={`/img/issue_logo_icons/${option?.value}_logo.jpg`} shape="circle"/>
                &nbsp;&nbsp;<div>{option.name}</div>
            </div>
        );
    };
    const selectedIcodeTemplate = (option, props) => {
        if (option) {
            return (
                <div className="flex align-items-center">
                   { option?.value ? <Avatar image={`/img/issue_logo_icons/${option?.value}_logo.jpg`} shape="circle"  className="absolute"/> : ''}
                   &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<div>{option.name}</div>
                </div>
            );
        }
        return <span>{props.placeholder}</span>;
    };
    const selectedBoardTemplate = (option, props) => {
        if (option) {
            return (
                <div className="flex align-items-center">
                   <div>{option.name}</div>
                </div>
            );
        }
        return <span>{props.placeholder}</span>;
    };

    return (
        <>
            <LogoHeader />

            <div className='col-12 -mt-3'>
                <div className="card p-4 shadow-3 border-round-lg bg-card">
                    <div className='grid mb-4'>
                        <div className='col-6 md:col-3'>
                            <Dropdown value={mType} onChange={onChangeMType} options={boards} valueTemplate={selectedBoardTemplate} optionLabel="name" placeholder="Select a Board" className="w-full border-round-lg"/>
                        </div>
                        <div className='col-6 md:col-3'>
                            <Dropdown value={icode} onChange={onChangeICode} options={icodes} valueTemplate={selectedIcodeTemplate} itemTemplate={icodeOptionTemplate} optionLabel="name" placeholder="Select a Stock" className="w-full border-round-lg"/>
                        </div>
                        <div className='col-6 md:col-3'>
                            <Calendar value={startDate} onChange={onChangeSDate} showIcon className="w-full border-round-lg"/>
                        </div>
                        <div className='col-6 md:col-3'>
                            <Calendar value={endDate} onChange={onChangeEDate} showIcon className="w-full border-round-lg"/>
                        </div>
                    </div>

                    <DataTable 
                        value={disclosures} 
                        tableStyle={{ minWidth: '30rem' }} 
                        className="text-white" 
                        tableClassName="bg-none"
                        loading={loading}
                    >
                        <Column field="ttime" align="center" header={t('Date')} body={dateBodyTemplate} className="border-blue-700 text-white p-0" headerClassName="p-0 pb-2" bodyClassName="p-0 py-1" style={{background: 'none'}}></Column>
                        <Column field="tprice" align="center" header={t('Stock Symbol')} body={symbolBodyTemplate} className="border-blue-700 text-white p-0 pb-2" headerClassName="p-0" bodyClassName="p-0 py-1" style={{background: 'none'}}></Column>
                        <Column field="cpday" align="center" header={t('Disclosure Type')} body={dTypeBodyTemplate} className="border-blue-700 text-white" headerClassName="p-0 pb-2" bodyClassName="p-0 py-1" style={{background: 'none'}}></Column>
                        <Column field="cpday" align="center" header={t('Title')} body={dTitleBodyTemplate} className="border-blue-700 text-white w-6" headerClassName="p-0 pb-2" bodyClassName="p-0 py-1 w-6" style={{background: 'none'}}></Column>
                    </DataTable>
                    <p className="paginate-label mt-4 text-sm flex justify-content-start">Page {disclosures.length > 0 ? currentPage : 0} of {totalPages}, showing {totalDisinPage} records out of {totalDis} total, starting on record {disclosures.length > 0 ?  (20 * (currentPage-1) + 1) : 0}, ending on {currentPage && (20*(currentPage-1) + totalDisinPage)}</p>
                    <div className="paginate text-sm  flex justify-content-start">
                        <div>
                            <ReactPaginate
                                breakLabel="..."
                                nextLabel={t("next")+" »"}
                                onPageChange={onChangePage}
                                pageRangeDisplayed={5}
                                pageCount={totalPages}
                                previousLabel={"« "+t('previous')}
                                renderOnZeroPageCount={null}
                                forcePage={disclosures.length > 0 ? currentPage - 1 : -1}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}